/**
 * Inventory Store
 *
 * @since 2018-04-12
 * @author dev014
 */

import Moment from 'moment'
import JSONBigInt from 'json-bigint'

export const state = () => ({
  apiPreFix: '/api/lr/log/', // 로그 기본 API url
  // ===  onSearch ===
  search: { // 로그 조회 현 정보
    id: '',
    page_num: 1,
    isFirst: true,
    end_id: ''
  },
  searchData: { // 로그 검색 정보
    log_type: '',
    stime: '',
    etime: '',
    total_rows: 10000,
    page_rows: 1000,
    order_by: 'desc',
    filters: []
  },
  searchState: { // 로그 검색 상태 정보
    status: '', // 초기 단계: INIT, 추이 검색 중: SEARCHING_TREND_LOG, 로그 검색 중: SEARCHING_LOG, 검색 중지 요청 중: REQUEST_STOP, 로그 검색이 중지 됨: STOPPED, 로그 검색 완료: DONE
    progress: 0,
    searched_cnt: 0
  },
  unitTime: {}, // 차트 상단의 컬럼 당 출력 정보
  trendData: [], // 차트 데이터
  // === Table Content  ===
  dataList: [], // 로그 조회 데이터
  chgFieldData: null // 시스템 자원 조회 시 추가 되어야 할 필드 정보
})

export const mutations = {
  // 로그 스토어 초기화
  initLogStore (state) {
    state.dataList = []
    state.trendData = []
  },
  // 로그 조회 시작 시 데이터 초기화
  startLogSearch (state, data) {
    state.trendData = []
    state.dataList = []

    if (state.chgFieldData != null) {
      state.search.isFirst = true
      state.chgFieldData = null
    }

    // state.search.id = data.search_id
    state.search.id = data.request_id
  },
  // 상태 조회 데이터 셋팅
  getSearchState (state, data) {
    state.searchState = Object.freeze(data)
  },
  // 차트 데이터 셋팅
  getTrendResult (state, data) {
    const trendD = _.cloneDeep(data.trend)
    _.each(trendD, (gD) => {
      gD.splice(1, 1)
      // gD[0] = new Date(gD[0]).getTime()
      gD[0] = Moment(gD[0]).valueOf()
    })
    state.trendData = Object.freeze(trendD)

    state.unitTime = Object.freeze(data.unit_time)
  },
  // 데이터 테이블 데이터 셋팅
  getSearchResult (state, data) {
    state.dataList = data.log
  },
  /*
    데이터 테이블 데이터 셋팅 및 유동성 헤더 추출
    - 시스템 자원 로그일 경우 헤더를 첫 데이터로 셋팅
  */
  getSearchResourseResult (state, data) {
    const addHeaders = (state.search.isFirst) ? [] : state.chgFieldData
    _.each(data.log, (rD, rDi) => {
      const sD = rD.cpu_usages
      if (state.search.isFirst) {
        _.each(sD, (subD, subI) => {
          if (rDi === 0) { // 첫번째 행일경우
            addHeaders.push(`cpu_usages_${subI}`)
          }
        })
        state.chgFieldData = _.clone(addHeaders)
        state.search.isFirst = false
      }

      _.each(addHeaders, (strH, strI) => {
        rD[strH] = sD[strI]
      })
    })
    state.dataList = data.log
  },
  // 검색 종료 후 조회 ID 초기화
  endSearch (state) {
    state.search.id = ''
  },
  // 차트 데이터, 테이블 데이터 초기화
  errorSearch (state) {
    state.trendData = []
    state.dataList = []
  }
}
export const actions = {
  // 로그 검색 start
  async startLogSearch ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${'start'}`
    try {
      state.search.page_num = 1
      result = await this.$axios.$post(apiUrl, state.searchData, {loading: false, successAlert: false})
      if (result.code === 'ok') {
        commit('startLogSearch', result.result)
      } else {
        commit('errorSearch')
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      commit('errorSearch')
      return result
    }
  },
  // 로그 검색 진행 상태 조회
  async getSearchState ({commit, state}) {
    let result = {}
    if (state.search.id === undefined || state.search.id === '') {
      result.code = 'nok'
      result.reason = 'search_id undefined'
      return result
    }
    const apiUrl = `${state.apiPreFix}${state.search.id}${'/status'}`
    try {
      result = await this.$axios.$get(apiUrl, {data: {request_id: state.search.id}, loading: false})
      if (result.code === 'ok') {
        // commit('getSearchState', result.result)
        state.searchState = result.result
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },
  // 로그 추이 결과 조회
  async getTrendResult ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.search.id}${'/trend'}`
    try {
      result = await this.$axios.$get(apiUrl, {data: {request_id: state.search.id}, loading: false})
      if (result.code === 'ok') {
        commit('getTrendResult', result.result)
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },
  // 로그 페이지 결과 조회
  async getSearchResult ({commit, state}) {
    let result = {}
    if (state.search.id === undefined || state.search.id === '') {
      result.code = 'nok'
      result.reason = 'search_id undefined'
      return result
    }
    const apiUrl = `${state.apiPreFix}${state.search.id}${'/page/'}${state.search.page_num}`
    try {
      result = await this.$axios.$get(apiUrl, {data: {request_id: state.search.id}, transformResponse: [(data) => { return JSONBigInt.parse(data) }]})
      if (result.code === 'ok') {
        state.dataList = setRowData(state.searchData.log_type, result.result.log)
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },
  // 검색 중지
  async stopSearch ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.search.id}${'/stop'}`
    try {
      result = await this.$axios.$delete(apiUrl, {data: {request_id: state.search.id}, loading: false, successAlert: false})
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  },
  // 기존 검색 끝!
  async endSearch ({commit, state}) {
    let result = {}
    if (state.search.id === undefined || state.search.id === '') {
      result.code = 'nok'
      result.reason = 'search_id undefined'
      return result
    }
    const reqId = state.search.id
    state.search.end_id = reqId
    const apiUrl = `${state.apiPreFix}${reqId}${'/end'}`
    try {
      result = await this.$axios.$delete(apiUrl, {data: {request_id: state.search.id}, loading: false, successAlert: false, errorAlert: false})

      if (reqId === state.search.id) {
        commit('endSearch', result.result)
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result = { msg: e }
      return result
    }
  }
}

function setRowData (logType, result) {
  if (logType === 'qos_dynamic') {
    const packetList = ['Outbound', 'Inbound']
    const statusList = ['Start', 'End']
    _.forEach(result, (item) => {
      item.packet_dir = _.isUndefined(packetList[item.packet_dir]) ? '' : _.cloneDeep(packetList[item.packet_dir])
      item.status = _.isUndefined(statusList[item.status]) ? '' : _.cloneDeep(statusList[item.status])
    })
  }
  if (logType === 'traffic_service_cnt') {
    const protocolList = [{value: 6, name: 'TCP'}, {value: 17, name: 'UDP'}]
    _.forEach(result, (item) => {
      const data = _.cloneDeep(_.find(protocolList, {'value': _.toNumber(item.protocol)}))
      item.protocol = _.isUndefined(data) ? '' : data.name
    })
  }
  if (logType === 'traffic_framesize_cnt') {
    const frameList = [
      {value: 0, name: '1~64'},
      {value: 1, name: '65~128'},
      {value: 2, name: '129~256'},
      {value: 3, name: '257~512'},
      {value: 4, name: '513~1024'},
      {value: 5, name: '1025~1518'},
      {value: 6, name: '1518~'}
    ]
    _.forEach(result, (item) => {
      const data = _.cloneDeep(_.find(frameList, {'value': _.toNumber(item.frame_size_id)}))
      item.frame_size_id = _.isUndefined(data) ? '' : data.name
    })
  }
  return result
}

export const getters = {}
export const strict = false
